import type { InternalRefetchQueriesInclude } from "@apollo/client";
import { useMutation } from "@apollo/client";
import type { SignalPayload } from "components/company/v3/types/SignalPayloadSchema";
import EmitSignalMutation from "lib/graphql/mutations/discussions/EmitSignalMutation";
import type { IMutationEmitSignalArgs, ISignalType } from "types/graphqlTypes";

export default function useEmitSignal() {
  const [emitSignalMutation, { loading, error }] = useMutation<boolean, IMutationEmitSignalArgs>(EmitSignalMutation);

  async function emitSignal<Signal extends ISignalType>(
    signal: Signal,
    payload: SignalPayload[Signal],
    refetchQueries?: InternalRefetchQueriesInclude,
  ) {
    await emitSignalMutation({
      variables: {
        signal,
        payload,
      },
      refetchQueries,
    });
  }

  return {
    emitSignal,
    loading,
    error,
  };
}
